// Module
var code = "<script>let $ctrl</script> <molecule-panel-wizard panel-title=\"{{ '5cffb074-33c6-41b4-95d5-3069d0bb7115' | translate }}\"> <panel-body> </panel-body> </molecule-panel-wizard> ";
// Exports
module.exports = code;